import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styled from "styled-components";

const LabelDetailItem = (props) => {
  const {
    label,
    description
  } = props;
  return (
    <MainContainer>
      <Row>
        <Col xl={12} lg={12} md={12} sm={12}>
          <Text fontWeight={'bold'} fontSize={16} paddingRight={10}>{label}</Text>
          <Text fontSize={16}>{description}</Text>
        </Col>
      </Row>
    </MainContainer>
  )
}

export default LabelDetailItem;

const MainContainer = styled.div`
    padding: 5px 5px 5px 20px;
`;

const Text = styled.span`
  font-weight: ${props => props.fontWeight ? props.fontWeight : "normal"};
  font-size: ${props => props.fontSize ? props.fontSize : 10}px;
  color: ${props => props.color ? props.color : 'black'};
  padding-right: ${props => props.paddingRight ? props.paddingRight : 0}px;
`;

